module.exports = __webpack_public_path__ + "static/img/fuwu.26c9f03b.png";